"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PostMessageEventType;
(function (PostMessageEventType) {
    PostMessageEventType["None"] = "None";
    PostMessageEventType["Request"] = "Request";
    PostMessageEventType["Response"] = "Response";
})(PostMessageEventType || (PostMessageEventType = {}));
exports.default = PostMessageEventType;
//# sourceMappingURL=PostMessageEventType.js.map